import { CONSTANTS } from "./callcentral.constants";

export const addPhoneNumConstants = [

    {
        phoneId: CONSTANTS.PHONE_NUM_OPTIONS.MOBILE,
        phoneName: "Mobile",
        isMenuSelected: false,
    },
    {
        phoneId: CONSTANTS.PHONE_NUM_OPTIONS.LANDLINE,
        phoneName: "Landline",
        isMenuSelected: false,
    }

];